"use client";

import { FC, PropsWithChildren } from "react";
import { useCookies } from "react-cookie";

import { createCustomContext } from "./context";
import { useProfileContext } from "./ProfileProvider";
import { COOKIES } from ".constants/cookies";
import { FEATURE_FLAGS } from ".constants/featureFlags";

interface IProps {
  EmailTriggerFree: boolean | null;
  EmailTriggerVip: boolean | null;
  AB_notification_balance: boolean;
}

const [Context, useABtestContext] = createCustomContext<IProps>({
  name: "ABtestContext",
});
export { useABtestContext };

export const ABtestProvider: FC<PropsWithChildren> = ({ children }) => {
  const profile = useProfileContext();
  // const headers = useHeadersContext();
  // const [cookies] = useCookies(["country"]);
  // const country = cookies.country ?? getCountry(headers);
  const [cookies] = useCookies([
    COOKIES.SUBSCRIBE_EMAIL_IS_SHOWED,
    COOKIES.SEGMENT_AB,
    COOKIES.GA_ABC,
  ]);

  /**
   * Триггеры для попапа с email
   */
  const EmailTriggerFree =
    !cookies.subscribeEmailIsShowed &&
    profile &&
    !profile.isEmailSubscribed &&
    profile.coins < 1;

  const EmailTriggerVip =
    !cookies.subscribeEmailIsShowed &&
    profile &&
    !profile.isEmailSubscribed &&
    profile.paymentCount > 0 &&
    profile.coins > 0;

  // AB тест нотификации о заканчивающемся балансе и прпомо пакета на 24ч
  // TODO: запустить после AB теста оживления
  // TODO: убрать AB тест после окончания
  const AB_notification_balance =
    FEATURE_FLAGS.IS_LOCAL_TEST &&
    !!profile &&
    profile.segment_ab === 1 &&
    profile?.ga_ab === 1;

  return (
    <Context
      value={{
        EmailTriggerFree,
        EmailTriggerVip,
        AB_notification_balance,
      }}
    >
      {children}
    </Context>
  );
};
